import React, { Component } from 'react'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import Dropzone from 'react-dropzone'
import AutosizeInput from 'react-input-autosize'
import { styles } from './text-styles.json'
import './App.css'
const R = require('ramda')
const slugify = require('slugify')
const nlp = require('compromise')
const stringSimilarity = require('string-similarity')
const deepEqual = require('deep-equal')

window.__eq = deepEqual

// style
// line-height

// weight
// letter-spacing

// TO DO
// add autoresize input for main group inputs
// whitespace no wrap on matching tab
//

class App extends Component {
    constructor(props) {
        super(props)

        // const newStyles = styles
        //     .map(x => {
        //         x.placeholder = slugify(x.name).toLowerCase()
        //         x.mobile = x.placeholder.indexOf('mobile') > -1
        //         return x
        //     })
        //     .sort((a, b) => {
        //         if (parseInt(a.size) < parseInt(b.size)) return -1
        //         if (parseInt(a.size) > parseInt(b.size)) return 1
        //         return 0
        //     })
        // const stylesMobile = newStyles.filter(
        //     x => x.placeholder.indexOf('mobile') > -1
        // )
        // const stylesNotMobile = newStyles.filter(
        //     x => x.placeholder.indexOf('mobile') === -1
        // )

        // let bestMatches = []
        // stylesMobile.forEach(s => {
        //     bestMatches.push({
        //         m: s.placeholder,
        //         d: stringSimilarity.findBestMatch(
        //             s.placeholder,
        //             stylesNotMobile.map(x => x.placeholder)
        //         ).bestMatch.target,
        //         active: true
        //     })
        // })

        this.state = {
            styles: [],
            stylesMobile: [],
            stylesNotMobile: [],
            groupIncludes: [{ findString: '', foundFonts: [] }],
            uniqueFonts: [],
            bestMatches: []
        }
        this.deleteGroupInclude = this.deleteGroupInclude.bind(this)
        this.updateGroupInclude = this.updateGroupInclude.bind(this)
        this.updateFontWeight = this.updateFontWeight.bind(this)
        this.updateFamilyString = this.updateFamilyString.bind(this)
        this.toggleMatchActive = this.toggleMatchActive.bind(this)
        this.onFileDrop = this.onFileDrop.bind(this)
    }

    setupStyles(styles) {
        const newStyles = styles
            .map(x => {
                x.placeholder = slugify(x.name).toLowerCase()
                x.mobile = x.placeholder.indexOf('mobile') > -1
                return x
            })
            .sort((a, b) => {
                if (parseInt(a.size) < parseInt(b.size)) return -1
                if (parseInt(a.size) > parseInt(b.size)) return 1
                return 0
            })
        const stylesMobile = newStyles.filter(
            x => x.placeholder.indexOf('mobile') > -1
        )
        const stylesNotMobile = newStyles.filter(
            x => x.placeholder.indexOf('mobile') === -1
        )

        let bestMatches = []
        stylesMobile.forEach(s => {
            bestMatches.push({
                m: s.placeholder,
                d: stringSimilarity.findBestMatch(
                    s.placeholder,
                    stylesNotMobile.map(x => x.placeholder)
                ).bestMatch.target,
                active: true
            })
        })

        this.setState({
            styles: newStyles,
            stylesMobile,
            stylesNotMobile,
            groupIncludes: [{ findString: '', foundFonts: [] }],
            uniqueFonts: [...new Set(styles.map(x => x.font))].sort(),
            bestMatches
        })
    }

    toggleMatchActive(m, d) {
        const { bestMatches } = this.state
        const match = bestMatches.filter(x => x.m === m && x.d === d)[0]
        match.active = !match.active
        this.setState({ bestMatches })
    }

    deleteGroupInclude(i) {
        let { groupIncludes } = this.state
        groupIncludes.splice(i, 1)
        this.setState({ groupIncludes })
    }

    updateGroupInclude(i, val) {
        let { groupIncludes, uniqueFonts } = this.state
        groupIncludes[i] = {
            findString: val,
            familyString: '',
            foundFonts:
                val === ''
                    ? []
                    : uniqueFonts.filter(f => f.indexOf(val) > -1).map(f => {
                          return { name: f, weight: '400', style: '' }
                      })
        }
        this.setState({ groupIncludes })
    }

    updateFamilyString(i, familyString) {
        let { groupIncludes } = this.state
        groupIncludes[i].familyString = familyString
        this.setState({ groupIncludes })
    }

    updateFontWeight(i, name, newWeight) {
        let { groupIncludes } = this.state
        groupIncludes[i].foundFonts.filter(
            x => x.name === name
        )[0].weight = newWeight
        this.setState({ groupIncludes })
    }

    updateFontStyle(i, name, newStyle) {
        let { groupIncludes } = this.state
        groupIncludes[i].foundFonts.filter(
            x => x.name === name
        )[0].style = newStyle
        this.setState({ groupIncludes })
    }

    onFileDrop(acceptedFiles) {
        acceptedFiles.forEach(file => {
            const reader = new FileReader()
            reader.onload = () => {
                const fileAsBinaryString = reader.result
                const { styles } = JSON.parse(fileAsBinaryString)
                this.setupStyles(styles)
                // do whatever you want with the file content
            }
            reader.onabort = () => console.log('file reading was aborted')
            reader.onerror = () => console.log('file reading has failed')

            reader.readAsBinaryString(file)
        })
    }

    render() {
        const {
            groupIncludes,
            uniqueFonts,
            styles,
            stylesMobile,
            stylesNotMobile,
            bestMatches
        } = this.state

        const filteredStyles = styles.filter(x =>
            groupIncludes.reduce((a, b) => {
                if (b.findString !== '') {
                    return x.font.indexOf(b.findString) > -1 ? a + 1 : a
                }
            }, 0)
        )

        const allSizes = [...new Set(filteredStyles.map(x => x.size))]
            .sort((a, b) => {
                if (parseInt(a) < parseInt(b)) return -1
                if (parseInt(a) > parseInt(b)) return 1
                return 0
            })
            .map((s, i) => {
                return { size: s, variable: `$font-size-${i + 1}` }
            })

        const allLineHeights = [
            ...new Set(
                filteredStyles.map(
                    x => Math.floor((1000 * x.lineHeight) / x.size) / 1000
                )
            )
        ]
            .sort((a, b) => {
                if (parseFloat(a) < parseFloat(b)) return -1
                if (parseFloat(a) > parseFloat(b)) return 1
                return 0
            })
            .map((lh, i) => {
                return { lineHeight: lh, variable: `$line-height-${i + 1}` }
            })

        const bestMatchesFiltered = bestMatches.filter(x => {
            return (
                filteredStyles.map(x => x.placeholder).indexOf(x.m) > -1 &&
                filteredStyles.map(x => x.placeholder).indexOf(x.d) > -1
            )
        })

        // Styles Mobile added to Styles Desktop and Removed from filtered styles
        const finalStyles = filteredStyles.filter(x => {
            const mobileNames = bestMatchesFiltered.map(z => z.m)
            return (
                mobileNames.indexOf(x.placeholder) === -1 ||
                (mobileNames.indexOf(x.placeholder) > -1 &&
                    bestMatchesFiltered.filter(z => {
                        return z.m == x.placeholder
                    })[0].active == false)
            )
        })

        console.log(
            finalStyles.filter(x => x.placeholder.indexOf('mobile') > -1)
        )

        const desktopPlaceholders = bestMatchesFiltered
            .filter(x => x.active)
            .map(x => x.d)

        finalStyles.forEach(s => {
            if (desktopPlaceholders.indexOf(s.placeholder) > -1) {
                const mPlaceholder =
                    bestMatchesFiltered[
                        desktopPlaceholders.indexOf(s.placeholder)
                    ].m
                s.mobileStyle = filteredStyles.filter(
                    fstyle => fstyle.placeholder === mPlaceholder
                )[0]
            } else {
                s.mobileStyle = false
            }
        })

        const finalPlaceholders = finalStyles
            .sort((a, b) => {
                if (parseInt(a.size) < parseInt(b.size)) return -1
                if (parseInt(a.size) > parseInt(b.size)) return 1
                return 0
            })
            .map(style => {
                const relatedGroupInclude = groupIncludes.filter(
                    x => style.font.indexOf(x.findString) > -1
                )[0]

                const foundFont = relatedGroupInclude.foundFonts.filter(
                    ff => ff.name === style.font
                )[0]

                const familyString = relatedGroupInclude.familyString
                const inlineFontFamily = `\n\tfont-family: ${familyString};`

                const inlineStyle =
                    foundFont.style === ''
                        ? ''
                        : `\n\tfont-style: ${foundFont.style};`

                const inlineWeight =
                    foundFont.weight == '400'
                        ? ''
                        : `\n\tfont-weight: ${foundFont.weight};`

                const inlineLetterSpacing =
                    style.spacing == '1' ||
                    style.spacing == '0' ||
                    style.spacing == null
                        ? ''
                        : `\n\tletter-spacing: ${Math.floor(
                              100 * style.spacing
                          ) / 100}em;`

                const getSize = val => {
                    return allSizes.filter(x => x.size === val)[0].variable
                }

                const getLineHeight = val => {
                    return allLineHeights.filter(x => x.lineHeight === val)[0]
                        .variable
                }

                let inlineFontSize,
                    inlineLineHeight,
                    inlineMobileStyle = ``
                if (!style.mobileStyle) {
                    inlineFontSize = `\n\tfont-size: ${getSize(style.size)};`
                    inlineLineHeight = `\n\tline-height: ${getLineHeight(
                        Math.floor((1000 * style.lineHeight) / style.size) /
                            1000
                    )};`
                } else {
                    inlineFontSize = `\n\tfont-size: ${getSize(
                        style.mobileStyle.size
                    )};`
                    inlineLineHeight = `\n\tline-height: ${getLineHeight(
                        Math.floor(
                            (1000 * style.mobileStyle.lineHeight) /
                                style.mobileStyle.size
                        ) / 1000
                    )};`
                    inlineMobileStyle = `\n\t@include breakpoint($breakpoint-type) {\n\t\tfont-size: ${getSize(
                        style.size
                    )};\n\t\tline-height: ${getLineHeight(
                        Math.floor((1000 * style.lineHeight) / style.size) /
                            1000
                    )};\n\t}`
                }

                return {
                    placeholder: style.placeholder,
                    inlineFontFamily,
                    inlineFontSize,
                    inlineLineHeight,
                    inlineStyle,
                    inlineWeight,
                    inlineLetterSpacing,
                    inlineMobileStyle
                }
            })

        var i = finalPlaceholders.length
        while (i--) {
            var j = finalPlaceholders.length
            while (j--) {
                if (
                    R.equals(
                        R.omit(['placeholder'], finalPlaceholders[i]),
                        R.omit(['placeholder'], finalPlaceholders[j])
                    ) &&
                    finalPlaceholders[i].placeholder !==
                        finalPlaceholders[j].placeholder
                ) {
                    finalPlaceholders[i].placeholder += `, %${
                        finalPlaceholders[j].placeholder
                    }`
                    finalPlaceholders.splice(j, 1)
                }
            }
        }

        return (
            <div className="App">
                <Tabs>
                    <header>
                        <TabList>
                            <Tab>Load</Tab>
                            <Tab>Group</Tab>
                            <Tab>Mobile Matching</Tab>
                            <Tab>Placeholders</Tab>
                        </TabList>
                    </header>
                    <TabPanel>
                        <h2>Load Text Styles</h2>
                        <Dropzone onDrop={this.onFileDrop} />
                    </TabPanel>
                    <TabPanel>
                        <h2>Group Fonts</h2>
                        <div className="group-includes">
                            <div className="group-include">
                                <h3>Unused Fonts</h3>
                                <ul>
                                    {uniqueFonts
                                        .filter(x => {
                                            return (
                                                groupIncludes
                                                    .reduce(
                                                        (a, b) =>
                                                            a.concat(
                                                                b.foundFonts.map(
                                                                    z => z.name
                                                                )
                                                            ),
                                                        []
                                                    )
                                                    .indexOf(x) === -1
                                            )
                                        })
                                        .map(x => (
                                            <li style={{ fontFamily: x }}>
                                                {x}
                                            </li>
                                        ))}
                                </ul>
                            </div>

                            {groupIncludes.map((x, i) => {
                                return (
                                    <div className="group-include">
                                        <AutosizeInput
                                            type="text"
                                            className="title"
                                            onKeyDown={e => {
                                                if (
                                                    e.key === 'Backspace' &&
                                                    e.target.value === '' &&
                                                    (i !== 0 ||
                                                        groupIncludes.length >
                                                            1)
                                                ) {
                                                    this.deleteGroupInclude(i)
                                                }
                                            }}
                                            onChange={e => {
                                                this.updateGroupInclude(
                                                    i,
                                                    e.target.value
                                                )
                                            }}
                                            value={x.findString}
                                        />
                                        <input
                                            type="text"
                                            placeholder="$font-sans"
                                            value={x.familyString}
                                            onChange={e => {
                                                this.updateFamilyString(
                                                    i,
                                                    e.target.value
                                                )
                                            }}
                                        />
                                        <ul>
                                            {x.foundFonts.map(foundFont => (
                                                <li
                                                    style={{
                                                        fontFamily:
                                                            foundFont.name
                                                    }}
                                                >
                                                    {foundFont.name}
                                                </li>
                                            ))}
                                        </ul>
                                        <ul>
                                            {x.foundFonts.map(foundFont => (
                                                <li className="found-font">
                                                    <h4>{foundFont.name}</h4>
                                                    <div className="found-font-option">
                                                        <span>Weight</span>
                                                        <select
                                                            value={
                                                                foundFont.weight
                                                            }
                                                            onChange={e => {
                                                                this.updateFontWeight(
                                                                    i,
                                                                    foundFont.name,
                                                                    e.target
                                                                        .value
                                                                )
                                                            }}
                                                        >
                                                            {[
                                                                ...Array(
                                                                    9
                                                                ).keys()
                                                            ].map(k => (
                                                                <option>
                                                                    {(k + 1) *
                                                                        100}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="found-font-option">
                                                        <span>Style</span>
                                                        <input
                                                            type="text"
                                                            placeholder={
                                                                'normal'
                                                            }
                                                            value={
                                                                foundFont.style
                                                            }
                                                            onChange={e => {
                                                                this.updateFontStyle(
                                                                    i,
                                                                    foundFont.name,
                                                                    e.target
                                                                        .value
                                                                )
                                                            }}
                                                        />
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )
                            })}
                            <button
                                onClick={e => {
                                    this.updateGroupInclude(
                                        groupIncludes.length,
                                        ''
                                    )
                                }}
                            >
                                Add +
                            </button>
                        </div>
                    </TabPanel>
                    <TabPanel>
                        <h2>Best Matches</h2>
                        <ul>
                            {bestMatchesFiltered.map(x => {
                                const mStyle = styles.filter(
                                    z => z.placeholder === x.m
                                )[0]
                                const dStyle = styles.filter(
                                    z => z.placeholder === x.d
                                )[0]
                                return (
                                    <li>
                                        <span
                                            style={{
                                                fontFamily: mStyle.font,
                                                fontSize: mStyle.size + 'px'
                                            }}
                                        >
                                            {x.m}
                                        </span>
                                        <input
                                            type="checkbox"
                                            checked={x.active}
                                            onChange={e => {
                                                this.toggleMatchActive(x.m, x.d)
                                            }}
                                        />{' '}
                                        <span
                                            style={{
                                                fontFamily: dStyle.font,
                                                fontSize: dStyle.size + 'px'
                                            }}
                                        >
                                            {x.d}
                                        </span>
                                    </li>
                                )
                            })}
                        </ul>
                    </TabPanel>
                    <TabPanel>
                        <h2>Placeholder</h2>
                        <code>
                            {`\n/* Variables */\n`}
                            {allSizes.map(x => `\n${x.variable}: ${x.size}px;`)}
                            {`\n`}
                            {allLineHeights.map(
                                x => `\n${x.variable}: ${x.lineHeight};`
                            )}
                            {`\n\n/* Placeholders */\n`}
                            {finalPlaceholders.map(p => {
                                return (
                                    <span>
                                        {`\n%${p.placeholder} {${
                                            p.inlineFontFamily
                                        }${p.inlineFontSize}${
                                            p.inlineLineHeight
                                        }${p.inlineStyle}${p.inlineWeight}${
                                            p.inlineLetterSpacing
                                        }${p.inlineMobileStyle}\n}\n`}
                                    </span>
                                )
                            })}
                        </code>
                    </TabPanel>
                </Tabs>
            </div>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js